export const stripeElementStyle = {
  base: { fontSize: '16px', color: '#222524', '::placeholder': { color: '#94A3B8' } },
  complete: { color: '#222524' },
};
